var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app"},[_c('van-doc',{attrs:{"lang":_vm.lang,"config":_vm.config,"versions":_vm.versions,"simulator":_vm.simulator,"has-simulator":_vm.hasSimulator,"lang-configs":_vm.langConfigs}},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }